import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environment/environment';

(window as any).pdfWorkerSrc = '/assets/pdf.worker.min.mjs';

// AG Grid Module Registration
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

// Review notes overlay for reviewers on dev; src/dev-tools/review-notes/README.md tells how to remove it
if (environment.reviewNotes) {
  import('./dev-tools/review-notes/review-notes').then(m =>
    m.installReviewNotes()
  );
}
